import React, { useEffect, useState } from 'react';
import 'rc-banner-anim/assets/index.css';
import { Button, Col, Modal, Row } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import ReactPlayer from 'react-player';
import { useTranslation } from 'react-i18next';

const Banner = (props) => {
  const { dataSource, ...restProps } = props;
  const { titleWrapper, page } = dataSource;
  const [videoShow, setVideoShow] = useState(false);
  const [playing, setPlaying] = useState(false);
  const { t,i18n } = useTranslation();
  const closeView = () => {
    setPlaying(false);
    setVideoShow(false);
  };

  return (
    <div {...restProps} {...dataSource.wrapper}>
      <div {...page}>
        <Row>
          <Col xl={12} md={24}>
            <img src={require(`@/assets/production/tool/tool-01${i18n.language === 'en' ? '_en' : ''}.png`)} style={{ width: '100%' }} />
          </Col>
          <Col xl={12} md={24}>
            <div {...titleWrapper}>
              <h1 {...titleWrapper.children[0]}>
                {t(titleWrapper.children[0].children)}
              </h1>
              <h2 {...titleWrapper.children[1]}>
                {titleWrapper.children[1].children}
              </h2>
              <div {...titleWrapper.children[2]}>
                <div dangerouslySetInnerHTML={{ __html: t(titleWrapper.children[2].children) }}></div>
              </div>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Banner;
